export default __webpack_public_path__ + "static/media/notification-user-sample.d9a36c8c.png";